import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetQueueRequests } from 'domain/usecases';
import { RemoteGetQueueRequests } from 'data/usecases';

export const makeRemoteQueueRequests = (): GetQueueRequests => {
  return new RemoteGetQueueRequests(makeApiUrl('/queue'), makeAuthorizeHttpClientDecorator());
};
